import * as React from 'react';
import { Component } from 'react';
import styles from '../styles/containers/SideBar.scss';
import LogoNewWideIcon from '../assets/images/logo-new-wide-66x11.svg';
import classNames from 'classnames';
import UncheckedIcon from '../assets/images/unchecked-15x15.svg';
import CheckedIcon from '../assets/images/checked-15x15.svg';
import NeutralIcon from '../assets/images/neutral-15x15.svg';
import { mapStateToProps, redirect } from '../core/utils';
import { withRouter } from 'react-router';
import ArrowDownMiddleIcon from '../assets/images/arrow-down-middle-15x15.svg';
import PlusMiddleIcon from '../assets/images/plus-middle-15x15.svg';
import MenuVIcon from '../assets/images/menu-v-15x15.svg';
import Tooltip from '../components/Tooltip';
import Dropdown from '../components/Dropdown';
import { hideDropdown } from '../redux/actions/general/dropdown';

@withRouter
@mapStateToProps((state) => ({
  router: state.router,
  sidebar: state.general.sidebar,
}))
class SideBar extends Component {
  render() {
    const MenuItem = (item) => {
      const onClick = () => {
        if (item.onClick) {
          item.onClick();
        } else if (item.link) {
          redirect(item.link());
        }
      };

      const active = () => {
        if (item.active) {
          if (_.isFunction(item.active)) {
            return item.active();
          } else {
            return item.active;
          }
        } else {
          return false;
        }
      };

      const checkbox_status = item.checkbox && item.checkbox.status();
      const Icon = item.expanded && item.expandedIcon
        ? item.expandedIcon
        : item.icon;

      return (
        <>
          <div
            className={classNames(styles.item, active() && styles.active)}
            onClick={onClick}
          >
            {item.onArrowClick && (
              <ArrowDownMiddleIcon
                className={classNames(
                  styles.arrow,
                  item.expanded && styles.expanded
                )}
                onClick={(e) => {
                  e.stopPropagation();

                  item.onArrowClick();
                }}
              />
            )}
            {!item.onArrowClick && <span className={styles.arrowPlaceholder} />}
            {Icon && <Icon className={styles.icon} />}
            <Tooltip text={item.title} placement='right'>
              <span
                className={classNames(
                  styles.name,
                  item.small_caps && styles.nameSmallCaps
                )}
              >
                {item.title}
              </span>
            </Tooltip>
            {!_.isNil(item.count) && (
              <span className={styles.count}>&middot; {item.count}</span>
            )}
            {(checkbox_status || item.addAction || item.menuAction) && (
              <div className={styles.actions}>
                {checkbox_status && (
                  <>
                    {checkbox_status == 'checked' && (
                      <CheckedIcon
                        className={styles.checked}
                        onClick={(e) => {
                          e.stopPropagation();

                          item.checkbox.onClick();
                        }}
                      />
                    )}
                    {checkbox_status == 'unchecked' && (
                      <UncheckedIcon
                        className={styles.unchecked}
                        onClick={(e) => {
                          e.stopPropagation();

                          item.checkbox.onClick();
                        }}
                      />
                    )}
                    {checkbox_status == 'neutral' && (
                      <NeutralIcon
                        className={styles.neutral}
                        onClick={(e) => {
                          e.stopPropagation();

                          item.checkbox.onClick();
                        }}
                      />
                    )}
                  </>
                )}
                {item.addAction && (
                  <Tooltip
                    text={item.addAction.tooltip || 'Add'}
                    placement='right'
                  >
                    <PlusMiddleIcon
                      className={styles.addAction}
                      onClick={(e) => {
                        e.stopPropagation();
                        item.addAction.onClick && item.addAction.onClick();
                      }}
                    />
                  </Tooltip>
                )}
                {item.menuAction && (
                  <Dropdown
                    top={24}
                    right={-10}
                    wrapperClassName={styles.dropdownWrapper}
                    name={'sidebar_menu_' + item.menuAction.id}
                    content={
                      <div className={styles.menuContent}>
                        {_.map(item.menuAction.items, (menuItem, i) => (
                          <div
                            key={i}
                            className={classNames(
                              styles.menuItem,
                              menuItem.disabled && styles.disabled
                            )}
                            onClick={(e) => {
                              e.stopPropagation();

                              if (menuItem.disabled) {
                                return;
                              }

                              hideDropdown();
                              menuItem.onClick && menuItem.onClick();
                            }}
                          >
                            {menuItem.title}
                          </div>
                        ))}
                      </div>
                    }
                  >
                    <Tooltip
                      text={item.menuAction.tooltip || 'Actions'}
                      placement='right'
                    >
                      <MenuVIcon className={styles.menuAction} />
                    </Tooltip>
                  </Dropdown>
                )}
              </div>
            )}
          </div>
          {!_.isEmpty(item.items) && (!item.onArrowClick || item.expanded) && (
            <div className={styles.subitems}>
              {_.map(item.items, (item, i) => (
                <MenuItem {...item} key={i} />
              ))}
            </div>
          )}
        </>
      );
    };

    return (
      <div
        className={classNames(
          styles.wrapper,
          (this.props.match.path == '/' || this.props.sidebar.hidden) &&
            styles.sidebarCollapsed
        )}
      >
        <div className={styles.logo}>
          <LogoNewWideIcon />
        </div>
        <div className={styles.module}>{this.props.sidebar.title}</div>
        <div className={styles.items}>
          {_.map(this.props.sidebar.items, (item, i) => (
            <MenuItem {...item} key={i} />
          ))}
        </div>
      </div>
    );
  }
}

export default SideBar;
